// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions } from 'redux-actions';

export const GET_DEVICE_INFO_DATA = 'GET_DEVICE_INFO_DATA';
export const GET_DEVICE_INFO_DATA_SUCCESS = 'GET_DEVICE_INFO_DATA_SUCCESS';
export const GET_DEVICE_INFO_DATA_FAIL = 'GET_DEVICE_INFO_DATA_FAIL';

export const GET_DEVICE_INFO_WARRANTY_DATA = 'GET_DEVICE_INFO_WARRANTY_DATA';
export const GET_DEVICE_INFO_WARRANTY_DATA_SUCCESS =
    'GET_DEVICE_INFO_WARRANTY_DATA_SUCCESS';
    
export const GET_CLAIM_DETAILS = 'GET_CLAIM_DETAILS';
export const GET_CLAIM_DETAILS_DATA_SUCCESS = 'GET_CLAIM_DETAILS_DATA_SUCCESS';
export const GET_CLAIM_DETAILS_DATA_FAIL = 'GET_CLAIM_DETAILS_DATA_FAIL';

export const {
    getDeviceInfoData,
    getDeviceInfoDataSuccess,
    getDeviceInfoDataFail,

    getDeviceInfoWarrantyData,
    getDeviceInfoWarrantyDataSuccess,

    getClaimDetails,
    getClaimDetailsDataSuccess,
    getClaimDetailsDataFail,
} = createActions(
    GET_DEVICE_INFO_DATA,
    GET_DEVICE_INFO_DATA_SUCCESS,
    GET_DEVICE_INFO_DATA_FAIL,

    GET_DEVICE_INFO_WARRANTY_DATA,
    GET_DEVICE_INFO_WARRANTY_DATA_SUCCESS,


    GET_CLAIM_DETAILS,
    GET_CLAIM_DETAILS_DATA_SUCCESS,
    GET_CLAIM_DETAILS_DATA_FAIL
);
